import type { IDirective } from "angular";
import { module } from "angular";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputNumberDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        irLabel: "<",
        irMax: "<?",
        irMin: "<?",
        ngModel: "=",
    };

    public template: string;

    public link = InputDirectiveFunctions.link; // eslint-disable-line @typescript-eslint/unbound-method

    public compile = InputDirectiveFunctions.compile(this.link);

    constructor() {
        this.template = `<input type="number" aa-field-group="ngModel"
               aa-label="{{irLabel | translate}}" min="{{irMin}}" max="{{irMax}}">`;
    }
}

module("mmGui").directive("irInputNumber", () => new InputNumberDirective());
